const Styles = {
  container: {
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
  },
  title: {
    color: "#8C8C8C",
    fontSize: 20,
  },
  familyId: {
    color: "#043D90",
  },
};

export default Styles;
